import {z} from 'zod';

import {optionalIsoDate, optionalText} from './catalogueUi';
import {optionalMoneyInput, priceInput} from './moneyInput';

// Kept as a plain object so newModelDraft can `.extend` it; window check is applied by consumers.
export const trimSchema = z.object({
  name: z.string().min(1),
  bodyStyle: z.string().trim().min(1),
  type: optionalText,
  validFrom: optionalIsoDate,
  validTo: optionalIsoDate,
  basePriceNet: priceInput,
  costNet: optionalMoneyInput,
});
